module.exports = __webpack_public_path__ + "static/media/2 4 Ordkjedetest-Feil-ost-par-vask-jakt.33dc96e9.mp3";